// SHOP SETTINGS -- edit these numbers. Square-foot prices, finishes, hinges and the minimum match
// plank & panel co's builder (checked 2026-10-11, their HDF 3/4", same PAC profiles).
window.SHOP = {
  name: "Hinge & Panel",
  currency: "USD",

  // "perDoor" = Artisan Doors model (base price per piece + width/height adds).
  // "sqft"     = price per square foot (pricePerSqFt + minSqFtPerPiece below).
  pricingModel: "sqft",

  // SIMPLE MODE: only these styles, Door / Drawer front only, drawing is view-only until the customer clicks
  // "Customize rails & stiles" (then mid rails, kerfs, stile/rail widths and hinge moving are available).
  // Set simple: false (and delete `styles`) to bring back every style and the design tools.
  simple: true,
  styles: ["SLAB", "CW01", "CW02", "CW03", "CW05", "CW13"],
  reducedRailUnder: 7,          // drawer fronts shorter than this (inches) automatically get the narrow-rail version
  // Photo of handwritten notes -> order lines. The address of the hp-photo-reader Cloudflare Worker
  // (C:\Users\Jeff\code\hp-photo-reader). Leave "" to hide the photo option.
  photoReaderUrl: "https://hp-photo-reader.hp-photo-reader.workers.dev",
  // Checkout at the exact price (a Shopify draft order made by the same worker). Leave "" to use the old
  // cart (N x $1.00 units, which also needs wholeDollarPrices: true).
  checkoutUrl: "https://hp-photo-reader.hp-photo-reader.workers.dev/order",
  sizeHelp: { framelessReveal: 0.125, pairGap: 0.125, overlays: [0.25, 0.375, 0.5, 0.625, 0.75, 1, 1.25], overlay: 0.5 },

  // perDoor: base price per piece by profile id. Anything not listed uses `default`.
  basePrice: {
    default: 35.00,
    CW11: 40.00, CW12: 40.00, CW18: 40.00   // raised panel styles
  },
  // Added to the base when a piece is OVER the size shown (inches). Matches artisan-doors.com.
  widthAdds:  [[18, 6], [23, 16], [29, 26], [36, 36]],
  heightAdds: [[23, 6], [30, 16], [45, 34], [60, 42], [70, 56]],

  // sqft: price per square foot by profile id (see profiles.js). Anything not listed uses `default`.
  pricePerSqFt: {
    default: 12.00,
    SLAB: 9.00,                                   // P&P Slab $9
    CW01: 12.00, CW03: 12.00, CW14: 12.00,        // Shaker, Double Shaker, Inside Bead: P&P $12
    CW05: 14.00,                                  // Slim Shaker: P&P $14
    CW08: 9.00,                                   // Auburn: P&P $9
    CW10: 11.00, CW11: 11.00,                     // Step Bead, Raised Panel Step Bead: P&P $11
    CW12: 11.00, CW16: 11.00, CW18: 11.00,        // Madison RP, Double Bead, Eric RP: like P&P's RP / In-Out Bead $11
    CW13: 9.00,                                   // Slim 150V: P&P Step 150V $9
    CW02: 12.00,                                  // 60V Shaker (60-degree bevel, flat panel): P&P Bevel Shaker $12
    CW04: 15.00                                   // 60V with Line: P&P Step 120V $15
    // not listed (Tacoma, Denver, Fuji, Skinny Bead) use default $12 -- P&P has no direct match
  },
  wholeDollarPrices: false,    // true rounds each piece up to whole dollars (only needed for the old $1-unit cart)
  minSqFtPerPiece: 0,         // (sq ft minimum, unused) -- small pieces use minPiecePrice instead
  minPiecePrice: 10.00,        // a piece's material (base + finish) is at least this (P&P: $10)
  glassUpchargePerDoor: 25.00, // glass-ready door (customer supplies glass)

  finishes: [
    { id: "raw",    name: "Raw",    desc: "Bare MDF straight off our machine. You sand lightly, prime and paint.", perSqFt: 0 },
    { id: "sanded", name: "Sanded", desc: "Sanded smooth and ready for your primer.", perSqFt: 4.00 },
    { id: "primed", name: "Primed", desc: "Sanded and primed. Just add your paint color.", perSqFt: 10.00 }
  ],
  hingeFromEnd: 4,             // inches from the door's top/bottom edge to the end hinge cups (customers can change per door)
  hingeBoring: [
    { id: "35",    name: "Yes, drill hinge cups", desc: "For hidden European-style hinges, the most common kind. If your old doors have a big round hole on the back, pick this. Doors only: drawer fronts never get hinge holes.", perDoor: 3.00 },
    { id: "35p",   name: "Cups + screw holes", desc: "Same hinge cups, plus 2 small pilot holes for each hinge's screws. Doors only: drawer fronts never get hinge holes.", perDoor: 3.00 },
    { id: "none",  name: "No hinge holes", desc: "Pick this if you will drill them yourself or use a different kind of hinge.", perDoor: 0 }
  ],

  // Size limits in inches
  minW: 4, maxW: 48, minH: 4, maxH: 96,
  maxSheet: { w: 48, h: 96 }
};
